import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { CommonService } from '../common/common.service';

@Injectable()
export class AuthGuard implements CanActivate {
  groupId: any;

  constructor(
    private oauthService: OAuthService,
    private router: Router,
    private _commonService: CommonService
  ) { }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    this.groupId = this._commonService.groupId;
    if (this.oauthService.hasValidAccessToken()) {
      return true;
    }
    this.router.navigateByUrl('' + this.groupId);
    return false;
  }
}
